(function () {
  function closeOneLevel(drawer) {
    if (!drawer) return false;

    // Schließt das zuletzt geöffnete Submenü
    const openDetails = drawer.querySelectorAll('details[open]');
    if (!openDetails.length) return false;

    const last = openDetails[openDetails.length - 1];
    last.removeAttribute('open');
    return true;
  }

  document.addEventListener(
    'click',
    function (e) {
      const backTrigger =
        e.target.closest('.menu-drawer__close-button') ||
        e.target.closest('.menu-drawer__back') ||
        e.target.closest('[data-menu-back]');

      if (!backTrigger) return;

      const drawer =
        backTrigger.closest('#Drawer-Menu') ||
        backTrigger.closest('side-drawer');

      if (!drawer) return;

      const handled = closeOneLevel(drawer);
      if (handled) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true
  );
})();
